import {Col, Container, Row, Form, InputGroup, FormControl} from "react-bootstrap";
import React, {useContext, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "context/action";
import {swiftWiresRefTypesJSON} from "../../pages/admin/swiftwires/SwiftWiresFilter";

export default function CompleteSwiftWiresModal(props) {

    const {setShowCompleteSwiftWires, setShow} = props;
    const {isDesktop} = useWindowDimensions();
    const {handleSwiftWiresComplete} = useContext(ActionPanelContext);
    const [canceling, setCanceling] = useState(false);
    const defaultRefType = swiftWiresRefTypesJSON.find(item => item.id !== '')?.id || '';
    const [refType, setRefType] = useState(defaultRefType);
    const [reference, setReference] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const {gridApi} = props;

    const selectedRows = gridApi?.getSelectedRows();

    return (<div className='modal-container'>
        <Container fluid className={props.isActionColBtn?"d-none":"my-3 my-md-0"}>
            <Row>
                <Col md={12}>
                    <h4 style={{textAlign: isDesktop?'left':'center'}}>Are you sure you want to complete the wire transaction?</h4>
                    <br/>
                </Col>
            </Row>
            <Row className={"pr-4"}>
                <Col md={6} xs={12}>
                    <Form.Group controlId="formGridRefType" className={'td-select'}>
                        <Form.Label className="filter-input-label">Ref Type:</Form.Label>
                        <Form.Control as="select" name="refType"
                                      value={refType}
                                      onChange={(e) => {
                                          setRefType(e.target.value);
                                          if (formErrors.refType) {
                                              setFormErrors({...formErrors, refType: null});
                                          }
                                      }}
                                      isInvalid={!!formErrors.refType}>
                            {
                                swiftWiresRefTypesJSON.filter(item => item['id'] !== '').map(item =>
                                    <option key={item['id']} value={item['id']}>{item['name']}</option>
                                )
                            }
                        </Form.Control>
                        <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.refType}</b></Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                    <Form.Group controlId="formGridReference">
                        <Form.Label className="filter-input-label">TD Reference:</Form.Label>
                        <FormControl
                            placeholder="" name="reference"
                            value={reference}
                            onChange={(e) => {
                                setReference(e.target.value);
                                if (formErrors.reference) {
                                    setFormErrors({...formErrors, reference: null});
                                }
                            }}
                            isInvalid={!!formErrors.reference}
                        />
                        <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.reference}</b></Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <br/>
            <Row className={"justify-content-end pr-4"}>
                <Col md={6} xs={12}>
                    <button disabled={canceling} className='btn btn-block td-btn-secondary-clear' href="#" onClick={() => {
                        setShow(false);
                        setShowCompleteSwiftWires(false);
                    }}>Cancel
                    </button>
                </Col>
                <Col md={6} xs={12}>
                    <button disabled={canceling} className={'btn btn-block td-btn-primary-light'} href="#" onClick={() => {
                        const onSuccess = () => {
                            setShow(false);
                            setShowCompleteSwiftWires(false);
                        };

                        const onError = (err) => {
                            setShow(false);
                            setShowCompleteSwiftWires(false);
                        };

                        const swiftWireReference = `/${refType}/${reference}`;
                        setCanceling(true);
                        handleSwiftWiresComplete(selectedRows, onSuccess, onError, swiftWireReference);
                    }}>Complete
                    </button>
                </Col>
            </Row>
        </Container>
    </div>)
}
CompleteSwiftWiresModal.defaultProps = {
    confirmCancelBtnClassName: "btn btn-block td-btn-red"
}
